<template>
  <b-form-group :label="label">
    <div class="password-input">
      <b-form-input
        :value="value"
        v-bind="$attrs"
        class="password-input__field"
        :type="inputType"
        :placeholder="placeholder"
        @input="$emit('input', $event)"
      />

      <button
        class="password-input__toggle"
        type="button"
        :aria-label="toggleLabel"
        @click="togglePasswordVisibility"
      >
        <b-icon :icon="toggleIcon" />
      </button>
    </div>
  </b-form-group>
</template>

<script>
import { computed, defineComponent, ref } from "vue";
import { useI18n } from "vue-i18n-composable";

export default defineComponent({
  name: "PasswordInput",
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  setup() {
    const { t: $t } = useI18n();

    const passwordVisible = ref(false);

    const inputType = computed(() => (passwordVisible.value ? "text" : "password"));

    const toggleIcon = computed(() => (passwordVisible.value ? "eye-slash" : "eye"));

    const toggleLabel = computed(() =>
      passwordVisible.value
        ? $t("components.forms.password_input.hide_password")
        : $t("components.forms.password_input.show_password")
    );

    const togglePasswordVisibility = () => {
      passwordVisible.value = !passwordVisible.value;
    };

    return {
      inputType,
      toggleIcon,
      toggleLabel,
      togglePasswordVisibility,
    };
  },
});
</script>

<style lang="scss">
.password-input {
  position: relative;

  .password-input__field {
    padding-right: 2.5rem;
  }

  .password-input__toggle {
    position: absolute;
    top: 50%;
    right: 0.75rem;
    z-index: 2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: #6c757d;
    line-height: 1;
    background: transparent;
    border: 0;
    transform: translateY(-50%);

    &:hover {
      color: #495057;
    }

    &:focus {
      outline: none;
    }
  }
}
</style>
